<template>
    <v-row align="center" class="flex-column my-0 mx-n16">
        <v-col cols="auto" class="pa-0">
            <v-card flat v-bind="{ loading }">
                <v-card-text>
                    <join-video />
                </v-card-text>
                <v-card-actions>
                    <v-row class="ma-n8">
                        <v-col cols="6" sm="4" lg="" class="pa-8">
                            <v-btn block class="border" @click="toggleAudio">
                                <template v-if="enabled_audio">
                                    <v-icon class="mr-8"> mdi-microphone-off </v-icon>
                                    <span> 마이크 끄기 </span>
                                </template>
                                <template v-else>
                                    <v-icon class="mr-8"> mdi-microphone </v-icon>
                                    <span> 마이크 켜기 </span>
                                </template>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4" lg="" class="pa-8">
                            <v-btn block class="border" @click="toggleMuted">
                                <template v-if="enabled_muted">
                                    <v-icon class="mr-8"> mdi-volume-high </v-icon>
                                    <span> 음소거 끄기 </span>
                                </template>
                                <template v-else>
                                    <v-icon class="mr-8"> mdi-volume-off </v-icon>
                                    <span> 음소거 켜기 </span>
                                </template>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4" lg="" class="pa-8">
                            <v-btn block class="border" @click="toggleVideo">
                                <template v-if="enabled_video">
                                    <v-icon class="mr-8"> mdi-camera-off </v-icon>
                                    <span> 화면 끄기 </span>
                                </template>
                                <template v-else>
                                    <v-icon class="mr-8"> mdi-camera </v-icon>
                                    <span> 화면 켜기 </span>
                                </template>
                            </v-btn>
                        </v-col>
                        <v-col cols="6" sm="4" lg="" class="pa-8">
                            <join-exec v-slot="{ icon, button, message, disabled }">
                                <v-btn block color="primary" v-bind="{ loading, disabled }" @click="join">
                                    <v-icon class="mr-8"> {{ icon }} </v-icon>
                                    <span :class="{ 'grey--text text--lighten-1': disabled }"> {{ button }} </span>
                                </v-btn>
                                <p class="mt-8 font-size-14 grey--text text--lighten-2 text-center">
                                    <span> {{ message }} </span>
                                </p>
                            </join-exec>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import { initInterview } from "@/assets/variables";
import { mapActions, mapMutations, mapState } from "vuex";

import JoinExec from "./join/join-exec.vue";
import JoinVideo from "./join/join-video.vue";

export default {
    components: {
        JoinExec,
        JoinVideo,
    },
    computed: {
        ...mapState("interview", ["loading"]),
        ...mapState("interview/client", ["enabled_audio", "enabled_video", "enabled_muted"]),
    },
    methods: {
        ...mapActions("interview/client", ["init"]),
        ...mapActions("interview/server", ["join"]),
        ...mapMutations("interview/client", ["toggleAudio", "toggleVideo", "toggleMuted"]),
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>